<template>
  <div class="container register">
    <h2 class="fw-bold text-dark text-center mb-4">Create Survival Kit for Ship Call</h2>
    <div class="glass-panel p-5 mt-5">
      <div class="text-center mb-5">
        <img class="logo" alt="logo" src="@lib/frontend/assets/new.png" style="max-height: 80px;">
      </div>
      <form>
        <div class="row g-4">
          <!-- Form fields will flow naturally -->
          <div class="col-md-4">
            <label for="dateInput" class="form-label text-muted small fw-bold mb-2">Date:</label>
            <input v-model="date" type="date" id="dateInput" class="form-control" required />
          </div>
          <div class="col-md-4">
            <label for="cruiseLine" class="form-label text-muted small fw-bold mb-2">Cruise Line:</label>
            <select id="cruiseLine" v-model="selectedCruiseLine" class="form-control">
              <option v-for="cruiseLine in Object.keys(groupedTemplates)" :value="cruiseLine" :key="cruiseLine">
                {{ cruiseLine }}
              </option>
            </select>
          </div>
          <div class="col-md-4" v-if="selectedCruiseLine">
            <label for="tourName" class="form-label text-muted small fw-bold mb-2">Tour Name:</label>
            <select id="tourName" v-model="selectedTemplate" class="form-control">
              <option v-for="template in groupedTemplates[selectedCruiseLine]" :value="template" :key="template.id">
                {{ template.attributes.tour_name }} (Ship is docked in {{ template.attributes.end_city }}) (Type: {{ template.attributes.type }})
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label for="dropOffLocation" class="form-label text-muted small fw-bold mb-2">Drop-off Location:</label>
            <select id="dropOffLocation" v-model="selectedDropOffLocation" class="form-control">
              <option v-for="location in locations" :value="location" :key="location.id">
                {{ location.attributes.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="pickUpLocation" class="form-label text-muted small fw-bold mb-2">Pick-up Location:</label>
            <select id="pickUpLocation" v-model="selectedPickUpLocation" class="form-control">
              <option v-for="location in locations" :value="location" :key="location.id">
                {{ location.attributes.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="undergroundStation" class="form-label text-muted small fw-bold mb-2">Closest Public Train Station:</label>
            <select id="undergroundStation" v-model="selectedUndergroundStation" class="form-control">
              <option v-for="location in locations" :value="location" :key="location.id">
                {{ location.attributes.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label for="emergencyContact" class="form-label text-muted small fw-bold mb-2">Emergency Contact:</label>
            <input id="emergencyContact" v-model="emergency_tc" type="text" class="form-control" placeholder="+49XXXXXXXXXXX" />
          </div>
          <div class="col-md-4">
            <label for="meetingTime" class="form-label text-muted small fw-bold mb-2">Meeting Time:</label>
            <input id="meetingTime" v-model="meeting_time" type="text" class="form-control" placeholder="Enter in HH:mm" />
          </div>
          <div class="col-md-4" v-if="showBusFields">
            <label for="busDepartureTime" class="form-label text-muted small fw-bold mb-2">Bus Return Departure Time:</label>
            <input id="busDepartureTime" v-model="busDepartureTime" type="text" class="form-control" placeholder="Enter in HH:mm" />
          </div>

          <div class="col-md-4" v-if="showTrainFields">
            <label for="trainStation" class="form-label text-muted small fw-bold mb-2">Departure Train Station:</label>
            <select id="trainStation" v-model="selectedTrainStation" class="form-control">
              <option v-for="location in locations" :value="location" :key="location.id">
                {{ location.attributes.name }}
              </option>
            </select>
          </div>
          
          <div class="col-md-4" v-if="showTrainFields">
            <label for="trainDepartureTime" class="form-label text-muted small fw-bold mb-2">Train Departure Time:</label>
            <input id="trainDepartureTime" v-model="trainDepartureTime" type="text" class="form-control" placeholder="Enter in HH:mm" />
          </div>

          <div class="col-md-4">
            <label for="euroExchange" class="form-label text-muted small fw-bold mb-2">Euro Exchange:</label>
            <select id="euroExchange" v-model="selectedEuroExchange" class="form-control">
              <option v-for="location in locations" :value="location" :key="location.id">
                {{ location.attributes.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="mt-5 text-center d-flex justify-content-center gap-3">
          <b-button variant="success" class="btn btn-primary-gradient px-5 py-2 rounded-pill shadow-sm fw-bold" @click="onSave">Submit</b-button>
          <b-button v-b-toggle.collapse-1 variant="info" class="btn btn-light px-4 py-2 rounded-pill shadow-sm fw-bold">Read Me</b-button>
        </div>
        <b-collapse id="collapse-1" class="mt-3">
          <b-card class="bg-light border-0 shadow-sm rounded-4 text-muted text-center p-3">
            Please enter the time in 24:00 format e.g. 17:45
          </b-card>
        </b-collapse>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: null,
      templates: [],
      locations: [],
      selectedCruiseLine: null,
      selectedTemplate: null,
      cruise_line: null,
      selectedDropOffLocation: null,
      selectedPickUpLocation: null,
      selectedEuroExchange: null,
      selectedUndergroundStation: null,
      busDepartureTime: "",
      meeting_time: "",
      emergency_tc: "",
      selectedTrainStation: null,
      trainDepartureTime: "",
      map: null,
      showMap: false,
      newTemplate: {
        locations: [],
      },
    };
  },
  computed: {
  groupedTemplates() {
    const grouped = {};
    this.templates.forEach(template => {
      const cruiseLineData = template.attributes?.cruise_line?.data;
      if (cruiseLineData) {
        const cruiseLineName = cruiseLineData.attributes?.name;
        if (cruiseLineName) {
          if (!grouped[cruiseLineName]) {
            grouped[cruiseLineName] = [];
          }
          grouped[cruiseLineName].push(template);
        }
      }
    });
    return grouped;
  },
  showBusFields() {
    return this.selectedTemplate && (this.selectedTemplate.attributes.type === 'Bus' || this.selectedTemplate.attributes.type === 'Train and Bus');
  },
  showTrainFields() {
    return this.selectedTemplate && (this.selectedTemplate.attributes.type === 'Train' || this.selectedTemplate.attributes.type === 'Train and Bus');
  }
},

  async mounted() {
    this.getTemplates();
    this.getLocations();
  },
  methods: {
    getTemplates() {
      this.$xhr.get("/api/sk-templates?populate=*")
        .then((result) => {
          console.log(result.data.data, "Template data fetched successfully");
          this.templates = result.data.data;
        })
        .catch((error) => {
          console.error("Error fetching template data:", error);
        });
    },
    getLocations() {
      this.$xhr.get("/api/sk-locations")
        .then((result) => {
          console.log(result.data.data, "Location data fetched successfully");
          this.locations = result.data.data;
        })
        .catch((error) => {
          console.error("Error fetching location data:", error);
        });
    },
    onSave() {
  let formattedBusDepartureTime = this.showBusFields ? this.formatTime(this.busDepartureTime) : null;
  let formattedTrainDepartureTime = this.showTrainFields ? this.formatTime(this.trainDepartureTime) : null;
  const formattedMeetingTime = this.formatTime(this.meeting_time);

  // Handle the case where only the train option is selected
  if (this.showTrainFields && !this.showBusFields) {
    formattedBusDepartureTime = formattedBusDepartureTime || '00:00:00';
  }
  // Handle the case where only the bus option is selected
  if (this.showBusFields && !this.showTrainFields) {
    formattedTrainDepartureTime = formattedTrainDepartureTime || '00:00:00';
  }

  if (formattedMeetingTime === null) {
    console.error('Invalid time format');
    return;
  }

  // Check if selected options are not null before accessing their id properties
  const data = {
    data: {
      busDepartureTime: formattedBusDepartureTime,
      meeting_time: formattedMeetingTime,
      train_departuretime: formattedTrainDepartureTime,
      sk_templates: this.selectedTemplate ? this.selectedTemplate.id : null,
      drop_off_location: this.selectedDropOffLocation ? this.selectedDropOffLocation.id : null,
      pick_up_location: this.selectedPickUpLocation ? this.selectedPickUpLocation.id : null,
      euro_exchange: this.selectedEuroExchange ? this.selectedEuroExchange.id : null,
      underground_station: this.selectedUndergroundStation ? this.selectedUndergroundStation.id : null,
      train_station: this.selectedTrainStation ? this.selectedTrainStation.id : null,
      date: this.date,
      emergency_tc: this.emergency_tc
    },
  };

  console.log('data', data);
  this.$xhr.post("/api/sk-items", { ...data })
    .then((result) => {
      console.log('result', result);
      this.$router.push({ name: 'templates', params: { templateId: this.selectedTemplate.id } });
    })
    .catch((error) => {
      console.error('Error saving data:', error);
    });
},


    formatTime(time) {
      if (time) {
        const parts = time.split(':');
        if (parts.length === 2) {
          return `${parts[0]}:${parts[1]}:00`;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.container.register {
  padding: 20px;
  max-width: 1400px;
}

.logo {
  margin: auto;
  display: flex;
  max-width: 330px;
}
</style>
